const ConfigCanalesDeContacto = {
    Autogestion: 12,
    Campanita: 13
}

export default ConfigCanalesDeContacto;